import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useCanDeleteScan from "shared/Scan/access/useCanDeleteScan";
import useTriggerScan from "shared/Scan/useTriggerScan";
import { showScanDetailsDrawer } from "views/Account/Scans/DetailsDrawer";

import { showDeleteConfirmation } from "../../DeleteConfirmation";
import { ScansListItem } from "../../../types";

const ScansTableDropdownCell = ({
  item: scan,
  ...cellProps
}: TableSimpleCellProps<ScansListItem>) => {
  const canDeleteScan = useCanDeleteScan()(scan);
  const { canTrigger, showTrigger, isTriggering, isTriggerDisabled, trigger } = useTriggerScan({
    scan,
    refetchQueries: ["SearchScans", "SearchScansCount"],
  });

  const handleDelete = () => {
    showDeleteConfirmation({ id: scan.id, name: scan.name });
  };

  const handleDetails = () => {
    showScanDetailsDrawer({ scan });
  };

  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Scan actions">
        <DropdownMenuItem onAction={handleDetails}>View details</DropdownMenuItem>
        {showTrigger && (
          <DropdownMenuItem
            onAction={trigger}
            isDisabled={isTriggerDisabled}
            loading={isTriggering}
            tooltip={canTrigger.message}
            tooltipPlacement="left"
          >
            Trigger scan
          </DropdownMenuItem>
        )}
        <DropdownMenuItem href={`/resources/scans/${scan.id}/settings`}>Settings</DropdownMenuItem>
        {(canDeleteScan.result || canDeleteScan.message) && (
          <DropdownMenuItem
            onAction={handleDelete}
            isDisabled={!canDeleteScan.result}
            tooltip={canDeleteScan.message}
            tooltipPlacement="left"
            danger
          >
            Delete scan
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default ScansTableDropdownCell;
